module.exports = "Run `files.stat` to check the status of your root directory ( `/` ) in IPFS. Be sure to return your result.\n"